import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from 'components/Modal/Modal';
import { Mail, MailCheck } from 'lucide-react';
import styles from './InviteProjectChooser.module.scss';

const INVITE_ROW_ICON_SIZE = 18;
const ALREADY_INVITED_NOTE = 'Already invited';

function InviteProjectChooser({
  modal,
  collaborations,
  onSendInvite,
  onCloseModal,
  isBriefInviteDisabled,
}) {
  return (
    <Modal show={!!modal} onExit={onCloseModal} backgroundExit closeButton>
      {modal ? (
        <div className={styles.inviteChooserBody}>
          <h2 className={styles.inviteChooserTitle}>Invite expert</h2>
          <p className={styles.inviteChooserHint}>
            Choose a job or start a new project.
          </p>
          <div className={styles.inviteChooserActions}>
            <Link
              to={`/${modal.username}/hire`}
              className={styles.inviteChooserJobBtn}
              onClick={onCloseModal}
            >
              Contact for new project
            </Link>
            <hr className={styles.inviteChooserDivider} />
            <p className={styles.inviteChooserSectionLabel}>
              Request application to:
            </p>
            {collaborations.map((brief, key) => {
              const disabled = isBriefInviteDisabled(brief);
              return (
                <button
                  key={brief.id != null ? brief.id : key}
                  type="button"
                  className={
                    disabled
                      ? `${styles.inviteChooserJobBtn} ${styles.inviteChooserJobBtnInvited}`
                      : styles.inviteChooserJobBtn
                  }
                  disabled={disabled}
                  onClick={() => {
                    if (!disabled) {
                      onSendInvite(brief, modal.userId);
                    }
                  }}
                >
                  {disabled ? (
                    <span className={styles.inviteChooserInvitedBlock}>
                      <MailCheck
                        className={styles.inviteChooserIconSent}
                        size={INVITE_ROW_ICON_SIZE}
                        aria-hidden
                      />
                      <span className={styles.inviteChooserInvitedBody}>
                        <span className={styles.inviteChooserJobText}>
                          {brief.text}
                        </span>
                        <span
                          className={styles.inviteChooserAlreadyInvitedNote}
                        >
                          {ALREADY_INVITED_NOTE}
                        </span>
                      </span>
                    </span>
                  ) : (
                    <span className={styles.inviteChooserJobRow}>
                      <Mail
                        className={styles.inviteChooserIconAvailable}
                        size={INVITE_ROW_ICON_SIZE}
                        aria-hidden
                      />
                      <span className={styles.inviteChooserJobText}>
                        {brief.text}
                      </span>
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </Modal>
  );
}

InviteProjectChooser.propTypes = {
  modal: PropTypes.shape({
    username: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
  }),
  collaborations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.node,
    })
  ),
  onSendInvite: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  isBriefInviteDisabled: PropTypes.func,
};

InviteProjectChooser.defaultProps = {
  modal: null,
  collaborations: [],
  isBriefInviteDisabled: () => false,
};

export default InviteProjectChooser;
